import React from "react";
import styles from "./PanelEmptyMessage.module.scss";

interface PanelEmptyMessageProps {
    children: React.ReactNode;
}

/**
 * @purpose Inline "nothing here yet" line for a details-panel section whose
 * header is owned by a parent accordion. For standalone empty states with a
 * heading and a call to action use `EmptyState` instead.
 */
export const PanelEmptyMessage: React.FC<PanelEmptyMessageProps> = ({
    children,
}) => <p className={styles.emptyMessage}>{children}</p>;
